import { useRecoilValue } from "recoil";
import React, { useEffect } from "react";
import { Icon, Menu } from "semantic-ui-react";

import { useIsMobile } from "./utils";
import { changeTheme, darkMode } from "./DarkModeToggle";

function Toolbar({ height, onSave, onCancel, tools }) {
  return (
    <div
      style={{
        width: "100%",
        height,
        left: 0,
        top: 0,
        zIndex: 10,
        position: "fixed",
      }}
    >
      <Menu icon style={{ height, zIndex: 20 }}>
        {onSave ? (
          <Menu.Item name="ok" onClick={onSave}>
            <Icon name="check" />
          </Menu.Item>
        ) : null}
        {onCancel ? (
          <Menu.Item name="cancel" onClick={onCancel}>
            <Icon name="cancel" />
          </Menu.Item>
        ) : null}

        <div style={{ margin: "auto" }}>{tools}</div>
      </Menu>
    </div>
  );
}

function PlayerModalComponent({ children, isDarkMode, open, toolbar, color, transparent, style, visibleHeight, clip }) {
  const isMobileDevice = useIsMobile();
  const parentRef = React.createRef();

  const parent = parentRef.current;

  useEffect(() => {
    if (parent == null) return;

    const tracksList = document.querySelector("#tracks").parentElement;

    const scrollListener = () => {
      tracksList.scrollTop = parent.scrollTop;
    };

    parent.addEventListener("scroll", this.scrollListener, false);

    return () => {
      parent.removeEventListener("scroll", scrollListener);
    }
  }, [parent])

  if (!open) return null;

  const root = document.querySelector("#root");

  if (root.children.length === 0) return null;

  const topHeight = isMobileDevice ? undefined : root.children[0].offsetHeight;

  let saveHandler = null;
  let cancelHandler = null;

  let tools = null;

  const content = React.Children.map(children, (child) => {
    if (!child) return;

    if (child.type === PlayerModal.Save) {
      saveHandler = child.props.onClick;
      return null;
    } else if (child.type === PlayerModal.Cancel) {
      cancelHandler = child.props.onClick;
      return null;
    } else if (child.type === PlayerModal.Tools) {
      tools = child;
      return null;
    }

    return React.cloneElement(child, { offset: topHeight });
  });

  const showToolbar = toolbar !== false;

  return (
    <div
      className={`player-modal ${isDarkMode ? "player-modal-dark" : ""
        }`}
      style={{
        display: open ? "block" : "none",
        top: showToolbar || isMobileDevice ? 0 : topHeight,
        backgroundColor: color,
        height: transparent ? 0 : "100%",
        width: transparent ? 0 : "100%",
        ...style,
      }}
      ref={parentRef}
    >
      {showToolbar ? (
        <Toolbar
          tools={tools}
          onSave={saveHandler}
          onCancel={cancelHandler}
          height={topHeight}
        />
      ) : null}

      <div
        className="modal-content"
        style={{
          width: transparent ? 0 : "100%",
          height: transparent ? 0 : "100%",
          left: 0,
          top: showToolbar ? topHeight : 0,
          position: "absolute",
          overflow: clip ? "hidden" : "auto"
        }}
      >
        {content}
      </div>
    </div>
  );
}

function PlayerModal(props) {
  const isDarkMode = useRecoilValue(darkMode);

  useEffect(() => {
    changeTheme(isDarkMode);
  }, [isDarkMode]);

  return <PlayerModalComponent {...props} isDarkMode={isDarkMode} />;
}

PlayerModal.Save = ({ children }) => {
  return children;
};

PlayerModal.Cancel = ({ children }) => {
  return children;
};

PlayerModal.Tools = ({ children }) => {
  return children;
};

export { PlayerModal };
